import { useTranslation } from 'react-i18next';

import styles from './TabBar.module.css';

export type Tab = 'backlog' | 'reports';

interface TabBarProps {
  active: Tab;
  onChange: (tab: Tab) => void;
}

// PARA-105 §7 — два таба верхнего уровня, переключаются напрямую (без стека).
// PARA-120 итерация 2 (Z-1): CSS-примитивные иконки (Lines/Bars) над подписью — по образцу
// etc/design-system/project/components/navigation/TabBar.jsx; цвет иконки следует активному
// состоянию через класс .active на родительской кнопке (CSS-каскад, без inline-стилей).
export function TabBar({ active, onChange }: TabBarProps): JSX.Element {
  const { t } = useTranslation('common');

  return (
    <nav className={styles.tabBar}>
      <button
        type="button"
        aria-current={active === 'backlog'}
        className={[styles.tab, active === 'backlog' && styles.active].filter(Boolean).join(' ')}
        onClick={() => onChange('backlog')}
      >
        <span className={styles.icon} aria-hidden="true">
          <span className={styles.lineWide} />
          <span className={styles.lineWide} />
          <span className={styles.lineNarrow} />
        </span>
        {t('tabs.backlog')}
      </button>
      <button
        type="button"
        aria-current={active === 'reports'}
        className={[styles.tab, active === 'reports' && styles.active].filter(Boolean).join(' ')}
        onClick={() => onChange('reports')}
      >
        <span className={`${styles.icon} ${styles.iconBars}`} aria-hidden="true">
          <span className={styles.barShort} />
          <span className={styles.barTall} />
          <span className={styles.barMid} />
        </span>
        {t('tabs.reports')}
      </button>
    </nav>
  );
}
